/* eslint-disable no-shadow */
export function state() {
  return {
    latchkey: {
      initialized: false,
      selectedLatchkey: '',
      previousSelectedLatchkey: '',
    },
    trueFit: {
      lastSelectedSize: null,
    },
    carouselSelectedImage: {
      currentPage: 1,
      firstAltDot: 1,
      currentPageOnHover: null,
    },
    expandable: {
      isOpen: null,
    },
    protectionPlan: {
      selectedProtectionPlan: {},
    },
  };
}

export const mutations = {
  set(state, { scope, key, value }) {
    state[scope][key] = value;
  },
  setToObj(state, {
    scope, key, objKey, value,
  }) {
    state[scope][key][objKey] = value;
  },
  deleteFromObj(state, { scope, key, objKey }) {
    delete state[scope][key][objKey];
  },
};

export const getters = {
};

export const actions = {
};
